import clsx from "clsx"
import FlagComponent, { CurrencyCode } from "./flag/flag"
import { BaseHTMLAttributes, FC } from "react";
import { SIZE } from "@/constants";

interface CurrencyValueProps extends Pick<BaseHTMLAttributes<HTMLDivElement>, "className">{
    amount?: number | null;
    currency?: CurrencyCode;
    className?: string;
    size: Extract<keyof typeof SIZE, "S" | "L">
}

const CurrencyValue: FC<CurrencyValueProps> = ({ amount, currency, size, className }) => {
    return <div className={clsx("flex flex-row gap-1 items-center ", 
        size === 'S' && 'gap-xs',
        size === 'L' && 'gap-sm',
        className
    )}>
        <span className={clsx(
            size === 'S' && 'prose-caption-12-semibold',
            size === 'L' && 'prose-caption-14-semibold',
            amount && amount && typeof amount == 'number' && amount > 0 ? 'transaction-debit' : 'transaction-credit'
        )}>{amount && typeof amount == 'number' && amount! > 0 ? '+ ' : undefined}{
            amount ? amount === 0 ? 0 : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(amount!)) : undefined
        } {currency}
        </span>
        {currency && currency && <FlagComponent size={size === 'L' ? 'M' : 'S'} currencyCode={currency as CurrencyCode} />}
    </div>
}

export { CurrencyValue };